<div class="license-panel">
  <div class="license-actions">
    <lib-cdw-button
      level="secondary"
      type="button"
      [disabled]="checking || !normalizedDomain"
      (buttonClick)="check()"
    >
      <lib-cdw-icon icon="workspace_premium" size="18px"></lib-cdw-icon>
      {{ checking ? 'Checking…' : 'Check License' }}
    </lib-cdw-button>
    <lib-cdw-button
      level="tertiary"
      type="button"
      [disabled]="checking || !normalizedDomain"
      (buttonClick)="check(true)"
    >
      <lib-cdw-icon icon="refresh" size="18px"></lib-cdw-icon>
      Refresh from Chargify
    </lib-cdw-button>
  </div>

  <p *ngIf="errorMessage" class="license-error">{{ errorMessage }}</p>

  <ng-container *ngIf="result as r">
    <div class="license-grid">
      <div class="license-item">
        <span class="license-label">Domain</span>
        <span class="license-value">{{ checkedDomain }}</span>
      </div>
      <div class="license-item">
        <span class="license-label">Chargify</span>
        <span class="license-chip" [attr.data-tone]="r.inChargify ? 'ok' : 'error'">
          {{ r.inChargify ? 'In Chargify' : 'Not in Chargify' }}
        </span>
      </div>
      <div class="license-item">
        <span class="license-label">Access Tier</span>
        <span class="license-chip" [attr.data-tone]="tierTone(r.access.tier)">
          {{ r.access.tier }}
        </span>
      </div>
      <div class="license-item">
        <span class="license-label">Active SKU</span>
        <span class="license-value">{{ r.access.activeSku || '—' }}</span>
      </div>
      <div class="license-item">
        <span class="license-label">Bundle</span>
        <span class="license-value">{{ r.access.bundle || '—' }}</span>
      </div>
      <div class="license-item">
        <span class="license-label">Expiry</span>
        <span class="license-value">
          {{ r.access.expiry ? (r.access.expiry | date: 'medium') : '—' }}
        </span>
      </div>
      <div class="license-item">
        <span class="license-label">Source</span>
        <span class="license-value">
          {{ r.fromCache ? 'Cached (up to 24h old)' : 'Live from Chargify' }}
        </span>
      </div>
    </div>

    <div *ngIf="subscriptionRows.length > 0" class="license-subs">
      <span class="license-label">Subscriptions</span>
      <ul class="license-sub-list">
        <li *ngFor="let row of subscriptionRows" class="license-sub-row">
          <span class="license-sub-sku">{{ row.sku }}</span>
          <span class="license-chip" [attr.data-tone]="tierTone(row.facts.tier)">
            {{ row.facts.tier }}
          </span>
          <span class="license-value">
            {{ row.facts.bundle ? 'via ' + row.facts.bundle : '' }}
          </span>
          <span class="license-value">
            {{ row.facts.expiry ? (row.facts.expiry | date: 'mediumDate') : '' }}
          </span>
        </li>
      </ul>
    </div>
  </ng-container>
</div>
